import { type FC } from 'react'
import { type FormikHelpers } from 'formik'
import { useTranslation } from 'react-i18next'

import { useGetProfileLastAddedAddress } from '~/profile/model/profile/hooks.js'
import { useSetTitle, useWizardContext } from '~/setup/model/context.js'
import { StepForm } from '../StepForm.js'
import {
  AgreedPlaceForm,
  useCreateAgreedPlaceValidationSchema,
} from '~/profile/view/preferences/setup/components/AgreedPlaceForm.js'
import { useSubmitPreference } from '~/profile/view/preferences/hooks/useSubmitPreference.js'
import { useGetAgreedPlacePreference } from '~/profile/view/preferences/hooks/useGetAgreedPlacePreference.js'
import { type AgreedPlaceFormValues } from '~/profile/view/preferences/model/model.js'

export const DeliveryPreferenceAgreedPlace: FC = () => {
  const { t } = useTranslation()
  const { onStepComplete } = useWizardContext()
  const { validationSchema } = useCreateAgreedPlaceValidationSchema()
  const { data: lastAddedAddress } = useGetProfileLastAddedAddress()
  const { initialFormValues, isLoadingPhoto } = useGetAgreedPlacePreference(lastAddedAddress?.addressId)
  const { submitPreference } = useSubmitPreference()

  useSetTitle(t('portal.profile.preferences.options.AgreedPlaceDelivery.title'))

  const handleSubmit = async (values: AgreedPlaceFormValues, helpers: FormikHelpers<AgreedPlaceFormValues>) => {
    try {
      await submitPreference(lastAddedAddress?.addressId!, {
        description: values.description,
        preferenceType: 'AgreedPlaceDelivery',
      })
      onStepComplete()
    } catch {
      helpers.setSubmitting(false)
    }
  }

  return (
    <StepForm
      enableReinitialize
      validateOnChange
      initialValues={initialFormValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <AgreedPlaceForm isLoadingPhoto={isLoadingPhoto} />
    </StepForm>
  )
}
